import { types } from 'mobx-state-tree';

const InfluencerCondensed = types
	.model({
		id: types.maybeNull(types.string),
		orderId: types.maybeNull(types.string),
		phoneNumber: types.maybe(types.string),
		name: types.maybeNull(types.string),
		email: types.maybeNull(types.string),
		inviteLink: types.maybeNull(types.string),
		revenue: types.maybeNull(types.string),
		// smsConsent: false, // once we start doing sms stuff, add this back in
		emailConsent: false,
	})
	.named('Influencer')
	.actions((self) => ({
		setEmail(email) {
			self.email = email;
		},
		setName(name) {
			self.name = name;
		},
		setOrderId(orderId) {
			self.orderId = orderId;
		},
		setRevenue(revenue) {
			self.revenue = revenue;
		},
		setInfluencer({ id, name, email, inviteLink, orderId, revenue }) {
			self.id = id;
			self.name = name;
			self.email = email;
			self.inviteLink = inviteLink;
			self.orderId = orderId;
			self.revenue = revenue;
		},
	}))
	.views((self) => ({
		/**
		 * kind of weird but this is here for 2 reasons:
		 *  1) The API currently requires orderId even if there is no purchase being made.  this value cannout be null/undefined
		 *  2) We now show the order id on the widget if it is passed via the parent window
		 *
		 * because of this, the order confirmation will show up with our fake order id after the influencer is made.  We need to
		 * We will set the orderId to a valid string ("none").  If it is "none", we won't show the order on the UI, else we show the orderId
		 */
		get displayOrderId() {
			return self.orderId?.toLowerCase() === 'none' ? undefined : self.orderId;
		},
	}));

export const Influencer = types.snapshotProcessor(InfluencerCondensed, {
	preProcessor(snapshot) {
		return snapshot
			? {
					...snapshot,
					id: `${snapshot.id}`,
					revenue: snapshot.revenue ? `${snapshot.revenue}` : null,
			  }
			: undefined;
	},
});
